import React from 'react'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import { Link, Redirect } from 'react-router-dom'
import * as Yup from 'yup'
import Button from '@mui/material/Button'
import { connect } from 'react-redux'
import { loginTeacher } from '../../actions/authTeacher'
import LockOpenIcon from '@mui/icons-material/LockOpen'
import { TextField } from 'formik-material-ui'
import { Formik, Form, Field } from 'formik'
import { Card, CardContent, useMediaQuery, useTheme } from '@mui/material'
import { ValuesSubmitTeacherLogin } from '../../types'
import { RootState } from '../../reducers'

interface Props {
  loginTeacher: any;
  auth: any;
}

const LoginTeacher: React.FC<Props> = ({ loginTeacher, auth: { isAuthenticated, user } }) => {
  const initialValues = {
    email: '',
    password: '',
  }

  const validationSchema = Yup.object({
    email: Yup.string()
      .email('Email is not correct')
      .required('Email is required'),
    password: Yup.string().required('Password is required'),
  })

  const onSubmit = async (values: ValuesSubmitTeacherLogin) => {
    const { email, password } = values
    loginTeacher(email, password)
  }

  const theme = useTheme()
  const matchesMD = useMediaQuery(theme.breakpoints.up('md'))
  const matchesLG = useMediaQuery(theme.breakpoints.up('lg'))

  if (isAuthenticated && user && user.role === 'teacher') {
    return <Redirect to="/teachers/dashboard" />
  }

  return (
    <div className='container' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Card style={{ maxWidth: matchesLG ? '70%' : matchesMD ? '70%' : '80%' }}>
        <CardContent>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            direction="column"
          >
            <Grid item style={{ marginTop: '1.5em' }}>
              <LockOpenIcon fontSize='large' color='primary' />
            </Grid>
            <Grid item>
              <Typography variant="h4" gutterBottom style={{ textAlign: 'center', textTransform: 'uppercase' }}>
                Sign in teacher account
              </Typography>
            </Grid>
            <Grid item>
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                {(formik) => {
                  return (
                    <Form>
                      <Field
                        component={TextField}
                        type="email"
                        label="Email"
                        name="email"
                        fullWidth
                        style={{ marginBottom: '1em' }}
                      />
                      <Field
                        component={TextField}
                        fullWidth
                        type="password"
                        label="Password"
                        name="password"
                        style={{ marginBottom: '1em' }}
                      />
                      <Button
                        fullWidth
                        color="primary"
                        variant="contained"
                        type="submit"
                        disabled={!formik.isValid}
                        style={{ color: 'white' }}
                      >
                        Sign in
                      </Button>
                      <Grid
                        container
                        alignItems="center"
                        justifyContent="center"
                        style={{ margin: '1em 0' }}
                      >
                        <Grid item>
                          <Typography variant="body1">
                            You don't have an account?
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Button
                            component={Link}
                            to="/teachers/register-teacher"
                            variant="text"
                            style={{
                              fontSize: '1rem',
                              textTransform: 'none',
                              fontWeight: 600,
                            }}
                            disableRipple
                          >
                            Sign up
                          </Button>
                        </Grid>
                      </Grid>
                    </Form>
                  );
                }}
              </Formik>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </div>
  );
}

const mapStateToProps = (state: RootState) => ({
  auth: state.auth,
})

export default connect(mapStateToProps, { loginTeacher })(LoginTeacher)
